// 🔧 schedule_builder.js
// ✅ Purpose: Schedule Builder for the LGV Demo Engine
// ✅ Features:
// - Creates realistic schedule items for demo events
// - Stores schedule items under /events/{eventId}/schedule_items
// - Uses demo event date as the schedule base
// - Keeps schedule data generation separate from Event Builder
// - Future-ready for AI-generated event schedules
// - Fully block-commented for clarity and future devs

import {
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../firebase";
import { logger } from "../../utils/logger";

import {
  buildDemoScheduleItems,
} from "../templates/schedule_defaults";

export const buildSchedule = async ({
  eventResult,
} = {}) => {
  if (!eventResult?.eventId) {
    throw new Error(
      "Schedule Builder requires an event."
    );
  }

  const scheduleItems =
    buildDemoScheduleItems({
      eventDoc:
        eventResult.eventDoc,
    });

  const createdScheduleItems = [];

  for (const scheduleItem of scheduleItems) {
    const scheduleDoc = {
      ...scheduleItem,

      demoSeed: true,

      createdAt:
        serverTimestamp(),

      updatedAt:
        serverTimestamp(),
    };

    const scheduleRef =
      await addDoc(
        collection(
          db,
          "events",
          eventResult.eventId,
          "schedule_items"
        ),
        scheduleDoc
      );

    createdScheduleItems.push({
      id: scheduleRef.id,

      ...scheduleDoc,
    });
  }

  logger.log(
    "📅 Schedule Builder completed.",
    {
      value: {
        eventId:
          eventResult.eventId,

        createdCount:
          createdScheduleItems.length,
      },
    }
  );

  return {
    builder: "schedule_builder",

    ready: true,

    createdCount:
      createdScheduleItems.length,

    createdScheduleItems,

    message:
      "Schedule Builder created demo schedule items.",
  };
};

export const buildScheduleShell =
async ({
  eventResult,
} = {}) => {
  if (!eventResult?.eventId) {
    return {
      builder: "schedule_builder",

      ready: false,

      createdCount: 0,

      message:
        "Schedule Builder requires an event.",
    };
  }

  return buildSchedule({
    eventResult,
  });
};